//Add Client
export const ADD_CLIENT ="ADD_CLIENT"
export const ADD_CLIENT_SUCCESS = "ADD_CLIENT_SUCCESS"
export const ADD_CLIENT_FAIL = "ADD_CLIENT_FAIL"

// Update Client
export const UPDATE_CLIENT ="UPDATE_CLIENT"
export const UPDATE_CLIENT_SUCCESS="UPDATE_CLIENT_SUCCESS"
export const UPDATE_CLIENT_FAIL="UPDATE_CLIENT_FAIL"
export const UPDATE_CLIENT_LOADING ="UPDATE_CLIENT_LOADING"
